import { render, staticRenderFns } from "./StudentScoreRecords.vue?vue&type=template&id=63cae2f2&scoped=true"
import script from "./StudentScoreRecords.vue?vue&type=script&lang=js"
export * from "./StudentScoreRecords.vue?vue&type=script&lang=js"
import style0 from "./StudentScoreRecords.vue?vue&type=style&index=0&id=63cae2f2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63cae2f2",
  null
  
)

export default component.exports